module.exports = __webpack_public_path__ + "media/Emergency2.c2c0d505.wav";